import { i18n } from 'i18next';
import z from 'zod';

import { passwordMinLength } from '../config';

const minLength = passwordMinLength;

export const loginSchema = (i18n: i18n) =>
    z.object({
        email: z
            .string()
            .min(1, { message: i18n.t('translation:auth.email.error.required') || '' })
            .email({
                message: i18n.t('translation:auth.email.error.required') || '',
            }),
        password: z.string().min(minLength, {
            message: i18n.t('translation:auth.password.error.length', { minLength }) || '',
        }),
    });

export type TLoginSchema = z.infer<ReturnType<typeof loginSchema>>;
